import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { GridColDef } from '@mui/x-data-grid';
import { HandlersApprovalQueueItem } from '../../app/athenaApiGen';
import AthenaStatusChip from '../../shared-theme/customizations/AthenaStatusChip';

dayjs.extend(utc);

const APPROVAL_QUEUE_COLS: GridColDef<HandlersApprovalQueueItem>[] = [
  {
    field: 'workflowName',
    headerName: 'Item',
    flex: 1,
    valueGetter: (param: string) => param ?? '-',
  },
  {
    field: 'workflowState',
    headerName: 'State',
    flex: 1,
    renderCell: (param) => <AthenaStatusChip workflowState={param.value} />,
  },
  {
    field: 'taskName',
    headerName: 'Task',
    flex: 1,
    valueGetter: (param: string) => param ?? '-',
  },
  {
    field: 'objectType',
    headerName: 'Type',
    flex: 1,
    valueGetter: (param: string) => param ?? '-',
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    width: 120,
    type: 'dateTime',
    valueFormatter: (params) => {
      // Return a formatted string from the Date object
      return params
        ? dayjs(new Date(params)).utc().format('MM/DD/YYYY').toString()
        : '-';
    },
  },
];

export { APPROVAL_QUEUE_COLS };
